import SimpleBar from 'simplebar-react';
import { styled } from '@mui/material/styles';
import type { ComponentType, ComponentProps } from 'react';

export const Scrollbar: ComponentType<ComponentProps<typeof SimpleBar>> =
    styled(SimpleBar)``;
